import {Box, Typography} from '@viptech/react-components'
import {useState} from 'react'
import {Face} from 'src/common/models/facial-recognition/FaceDTO'
import SlideTypography from 'src/components/SlideTypography'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import arrowIcon from 'src/images/arrowWhiteRightIcon.svg'
import styled from 'styled-components'
import PhotoCard from './PhotoCard'

interface Props {
  onClick: (face: Face) => void
  face: Face
  isSelected: boolean
}

export function FaceBindingFrame({onClick, isSelected, face}: Props) {
  const [currentIndex, setCurrentIndex] = useState(0)
  const {styledTheme} = usePersonalizedThemeByCompany()

  const nextImage = () => {
    const faceImagesLength = face.faceImages?.length || 0
    setCurrentIndex((prevIndex) => (prevIndex + 1) % faceImagesLength)
  }

  const prevImage = () => {
    const faceImagesLength = face.faceImages?.length || 0

    setCurrentIndex((prevIndex) => (prevIndex - 1 + faceImagesLength) % faceImagesLength)
  }

  return (
    <>
      <Box
        width='fit-content'
        height='fit-content'
        padding='8px'
        border={isSelected ? '1px solid #D0D5DD' : ''}
        backgroundColor={isSelected ? `${styledTheme.advancedFilter.backgroundColor}` : '#F2F4F7'}
        onClick={() => onClick(face)}
        style={{cursor: 'pointer', outline: isSelected ? `1px solid ${styledTheme.colors.primary}` : '', outlineOffset: '4px'}}>
        <Box width='128px' display='flex' rowGap='8px' direction='column'>
          <Box key={currentIndex} position='relative'>
            <PhotoCard
              width='128px'
              height='136px'
              src={`${process.env.REACT_APP_TEMPLATE_IMAGES_BASE_URL}/${face.faceImages?.[currentIndex]?.aws_cropped_image_key}`}
              style={{cursor: 'pointer'}}
            />
            {face.faceImages && face.faceImages.length > 1 && (
              <>
                <Box display='flex' position='absolute' width='128px' justify='flex-end'>
                  <Typography
                    variant='label'
                    size='10px'
                    weight={700}
                    color={isSelected ? '#0F4C81' : '#667085'}>{`${currentIndex + 1}/${face.faceImages.length}`}</Typography>
                </Box>
                <Box display='flex' justifyContent='space-between' position='absolute' width='128px' style={{bottom: '4px'}}>
                  <ArrowButton
                    onClick={(e) => {
                      e.stopPropagation()
                      prevImage()
                    }}>
                    <img src={arrowIcon} alt='Arrow left' style={{transform: 'rotate(180deg)', width: '20px'}} />
                  </ArrowButton>
                  <ArrowButton
                    onClick={(e) => {
                      e.stopPropagation()
                      nextImage()
                    }}>
                    <img src={arrowIcon} alt='Arrow right' style={{width: '20px'}} />
                  </ArrowButton>
                </Box>
              </>
            )}
          </Box>

          <Box>
            <SlideTypography variant='label' size='12px' weight={isSelected ? 700 : 600} color={isSelected ? '#0F4C81' : '#667085'}>
              {face.name}
            </SlideTypography>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export const ArrowButton = styled(Box)`
  cursor: pointer;
  height: 24px;
  width: 24px;
  margin: 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 24px;
  transition: 0.3s ease-in-out;
  background-color: #00000050;
  box-shadow: 2px 0 8px rgba(255, 255, 255, 0.4);

  :hover {
    background-color: #00000060;
  }
`
